export default "<div nz-row [nzGutter]=\"24\" >\n  <div nz-col nzSpan=\"24\">\n    <span [innerHTML]=\"oneComponent['model']\"></span>\n  </div>\n</div>\n\n\n"